import React from 'react';
import './Footer.css';

const Footer = (props) => {
    return (
        <footer>
            <div className="bg-light">
                <div className="container-fluid py-3">
                    <a href="http://www.j0w0.com" target="_blank" rel="noopener noreferrer">j0w0</a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;